import { render, staticRenderFns } from "./KLineWithMA.vue?vue&type=template&id=1d644e05&"
import script from "./KLineWithMA.vue?vue&type=script&lang=js&"
export * from "./KLineWithMA.vue?vue&type=script&lang=js&"
import style0 from "./KLineWithMA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports